import { CircularProgress, Paper, Theme } from '@mui/material';
import { api } from '@verifime/api-definition';
import { VerificationRequestedBy } from '@verifime/components';
import { useEffect, useState } from 'react';
import { TLogoResponse } from '../types';

export default function ClientLogoByTrackId({
  trackId,
  title,
}: Readonly<{ trackId: string; title?: string }>) {
  const [logoResponse, setLogoResponse] = useState<TLogoResponse | null>(null);
  // The component is already loading, correctness-wise, from the moment it holds a trackId: the
  // fetch that trackId implies has not run yet, so there is nothing to show but the loading
  // state. Seeding from `useState(false)` asserts the opposite for exactly one render (the one
  // before the mount effect starts the fetch), which is a real, incorrect claim about the
  // component's state, not a stylistic choice.
  const [loading, setLoading] = useState(!!trackId);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!trackId) {
      setLogoResponse(null);
      return;
    }
    setLoading(true);
    setIsError(false);
    api
      .getV1logotrackingTrackingReference({ params: { trackingReference: trackId } })
      .then((res) => setLogoResponse(res))
      .catch(() => setIsError(true))
      .finally(() => setLoading(false));
  }, [trackId]);

  if (loading) {
    return (
      <Paper
        sx={(theme: Theme) => ({
          width: '100%',
          padding: theme.semantic.spacing.base,
          minHeight: theme.semantic.size['3xs'],
        })}
      >
        <CircularProgress />
      </Paper>
    );
  }

  if (!logoResponse || isError) {
    return;
  }

  return (
    <VerificationRequestedBy
      url={logoResponse.url}
      organisationName={logoResponse.organisationName}
      title={title}
    />
  );
}
